import { auth } from "firebase";
import React from "react";
import styled from "styled-components";

const Text = styled.p`
  color: ${(props) => props.theme.errorRedColor};
  margin: 2rem;
  width: 100%;
  text-align: center;
`;

const Me = () => {
  return (
    <Text
      onClick={() => {
        auth().signOut();
      }}
    >
      Sign Out
    </Text>
  );
};
export default Me;
